import * as React from 'react'
import joinClassNames from '../../../helpers/joinClassNames'

const AUTOCOMPLETE_MAP = {
    name: 'given-name',
    surname: 'family-name',
    www: 'url',
}

type Props = {
    label: string
    name: string
    type?: string
    isRequired: boolean
    pattern?: string
    wrapperClassName?: string
    isSmall?: boolean
}

const Field = ({label, name, type = 'text', isRequired, isSmall, pattern, wrapperClassName}: Props) => {
    const placeholder = isRequired ? `${label}*` : label

    return (
        <div className={joinClassNames('field', wrapperClassName || '')}>
            <div className="control has-margin-auto">
                <input
                    name={name}
                    aria-label={name}
                    className={joinClassNames('input', isSmall ? '' : 'is-large')}
                    type={type}
                    required={isRequired}
                    placeholder={placeholder}
                    pattern={pattern}
                    autoComplete={AUTOCOMPLETE_MAP[name]}
                />
            </div>
        </div>
    )
}

export default Field
